<!-- eslint-disable -->

<div class="landing-page">
  <!-- ════ Shared SVG gradient defs (referenced by all sparklines) ════ -->
  <svg width="0" height="0" style="position: absolute; overflow: hidden; pointer-events: none">
    <defs>
      <linearGradient id="sg-green" x1="0" x2="0" y1="0" y2="1">
        <stop offset="0%" stop-color="#1f9d6a" stop-opacity="0.25" />
        <stop offset="100%" stop-color="#1f9d6a" stop-opacity="0" />
      </linearGradient>
      <linearGradient id="sg-light" x1="0" x2="0" y1="0" y2="1">
        <stop offset="0%" stop-color="#86d4af" stop-opacity="0.25" />
        <stop offset="100%" stop-color="#86d4af" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>

  <!-- ════════════════ NAV ════════════════ -->
  <nav class="nav">
    <a class="nav__logo" routerLink="/">
      <img src="/images/miyzan-logo.png" alt="Miyzan" class="nav__logo__img" />
    </a>
    <div class="nav__links">
      <a href="#platform">{{ 'LANDING.NAV.PLATFORM' | translate }}</a>
      <a href="#modules">{{ 'LANDING.NAV.MODULES' | translate }}</a>
      <a href="#pricing">{{ 'LANDING.NAV.PRICING' | translate }}</a>
      <a href="#connection">{{ 'LANDING.NAV.CONTACT' | translate }}</a>
    </div>
    <span class="nav__sep"></span>
    <div class="nav__right">
      <div class="nav__lang" [class.nav__lang--open]="langOpen()">
        @if (langOpen()) {
          <div class="nav__lang__backdrop" (click)="langOpen.set(false)"></div>
        }
        <!-- Trigger button -->
        <button
          class="nav__lang__btn"
          (click)="langOpen.set(!langOpen())"
          aria-label="Tilni tanlash"
        >
          <div class="nav__lang__icon">
            @if (languageService.currentLang() === 'ru') {
              <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
                <rect width="36" height="12" fill="#fff" />
                <rect y="12" width="36" height="12" fill="#003DA5" />
                <rect y="24" width="36" height="12" fill="#CC0000" />
              </svg>
            } @else if (languageService.currentLang() === 'en') {
              <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
                <rect width="36" height="36" fill="#012169" />
                <path
                  d="M0,0 L36,36 M36,0 L0,36"
                  stroke="#fff"
                  stroke-width="7"
                  stroke-linecap="square"
                />
                <path
                  d="M0,0 L36,36 M36,0 L0,36"
                  stroke="#C8102E"
                  stroke-width="4"
                  stroke-linecap="square"
                />
                <rect x="14.5" y="0" width="7" height="36" fill="#fff" />
                <rect x="0" y="14.5" width="36" height="7" fill="#fff" />
                <rect x="16" y="0" width="4" height="36" fill="#C8102E" />
                <rect x="0" y="16" width="36" height="4" fill="#C8102E" />
              </svg>
            } @else {
              <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
                <rect width="36" height="13" fill="#0099B5" />
                <rect y="13" width="36" height="1.5" fill="#fff" />
                <rect y="14.5" width="36" height="7" fill="#fff" />
                <rect y="21.5" width="36" height="1.5" fill="#fff" />
                <rect y="23" width="36" height="13" fill="#1EB53A" />
                <circle cx="10" cy="6.5" r="4" fill="#fff" />
                <circle cx="12" cy="6.5" r="3.2" fill="#0099B5" />
                <circle cx="16.5" cy="4" r="0.9" fill="#fff" />
                <circle cx="18.8" cy="3" r="0.9" fill="#fff" />
                <circle cx="21" cy="4" r="0.9" fill="#fff" />
                <circle cx="16.5" cy="9" r="0.9" fill="#fff" />
                <circle cx="21" cy="9" r="0.9" fill="#fff" />
              </svg>
            }
          </div>
          <svg class="nav__lang__caret" viewBox="0 0 10 6" fill="none">
            <path
              d="M1 1l4 4 4-4"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        <!-- Dropdown menu -->
        @if (langOpen()) {
          <div class="nav__lang__menu" role="listbox">
            @for (l of langs; track l.code) {
              <button
                class="nav__lang__opt"
                [class.is-active]="languageService.currentLang() === l.code"
                (click)="selectLang(l.code)"
                role="option"
              >
                <span class="nav__lang__opt__flag">{{ l.flag }}</span>
                <span class="nav__lang__opt__label">{{ l.label }}</span>
                @if (languageService.currentLang() === l.code) {
                  <svg class="nav__lang__opt__check" viewBox="0 0 14 10" fill="none">
                    <path
                      d="M1 5l4 4L13 1"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                }
              </button>
            }
          </div>
        }
      </div>
      <a class="btn btn--ghost nav__signin" routerLink="/login">{{
        'LANDING.NAV.SIGNIN' | translate
      }}</a>
    </div>
  </nav>

  <!-- ════════════════ HERO ════════════════ -->
  <header class="hero">
    <div class="hero__grain"></div>
    <div class="hero__orb hero__orb--a"></div>
    <div class="hero__orb hero__orb--b"></div>
    <div class="hero__orb hero__orb--c"></div>

    <div class="particles">
      @for (p of heroParticles; track p.left) {
        <span
          class="particle"
          [style.left]="p.left"
          [style.bottom]="p.bottom"
          [style.animationDuration]="p.duration + 's'"
          [style.animationDelay]="p.delay + 's'"
          [style.transform]="'scale(' + p.scale + ')'"
        ></span>
      }
    </div>

    <div class="wrap hero__inner">
      <!-- Left -->
      <div class="hero__left">
        <h1 class="hero__h1">
          {{ 'LANDING.HERO.H1' | translate }}<br />
          <span class="grad">{{ 'LANDING.HERO.H1_GRAD' | translate }}</span>
        </h1>
        <p class="hero__lede"><b>Miyzan</b> — {{ 'LANDING.HERO.LEDE' | translate }}</p>
        <div class="hero__cta">
          <button class="btn btn--emerald btn--lg" (click)="scrollTo('apply')">
            {{ 'LANDING.HERO.CTA_PRIMARY' | translate }}
          </button>
          <button class="btn btn--ghost btn--lg" (click)="scrollTo('modules')">
            ▶ {{ 'LANDING.HERO.CTA_DEMO' | translate }}
          </button>
        </div>
        <div class="hero__meta">
          <div class="hero__meta__item">
            {{ 'LANDING.HERO.META_OFFLINE_LABEL' | translate
            }}<b>{{ 'LANDING.HERO.META_OFFLINE_VALUE' | translate }}</b>
          </div>
          <div class="hero__meta__item">
            {{ 'LANDING.HERO.META_SYNC_LABEL' | translate
            }}<b>{{ 'LANDING.HERO.META_SYNC_VALUE' | translate }}</b>
          </div>
        </div>
      </div>

      <!-- Right: 3D dashboard card -->
      <div class="hero__viz">
        <div class="hero__card hero__card--main">
          <!-- header row -->
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              position: relative;
              z-index: 1;
            "
          >
            <div
              style="
                display: flex;
                align-items: center;
                gap: 10px;
                font-size: 13px;
                font-weight: 700;
                letter-spacing: -0.02em;
              "
            >
              <span
                style="
                  width: 18px;
                  height: 18px;
                  border-radius: 6px;
                  background: linear-gradient(135deg, oklch(0.7 0.18 156), oklch(0.4 0.18 156));
                  display: inline-block;
                "
              ></span>
              Miyzan · Tarmoqli panel
            </div>
            <span style="font-size: 10px; font-family: var(--ff-mono); color: #86d4af"
              >● 12 / 12 onlayn</span
            >
          </div>
          <!-- revenue -->
          <div style="position: relative; z-index: 1">
            <div
              style="
                font-size: 11px;
                color: rgba(232, 240, 235, 0.55);
                font-family: var(--ff-mono);
                letter-spacing: 0.06em;
                text-transform: uppercase;
              "
            >
              Bugungi aylanma
            </div>
            <div
              style="
                font-size: 44px;
                font-weight: 800;
                letter-spacing: -0.04em;
                font-family: var(--ff-mono);
                line-height: 1;
                margin-top: 4px;
              "
            >
              UZS 4.82M
            </div>
            <div style="display: flex; gap: 6px; margin-top: 10px">
              <span
                style="
                  background: linear-gradient(180deg, #2cb87d, #178654);
                  color: white;
                  padding: 5px 12px;
                  border-radius: 999px;
                  font-size: 11px;
                  font-weight: 700;
                  box-shadow: 0 6px 18px -4px rgba(40, 160, 110, 0.55);
                "
                >▲ 18.2%</span
              >
              <span
                style="
                  background: rgba(255, 255, 255, 0.06);
                  color: rgba(232, 240, 235, 0.8);
                  padding: 5px 12px;
                  border-radius: 999px;
                  font-size: 11px;
                  font-family: var(--ff-mono);
                "
                >142 terminal · jonli</span
              >
            </div>
          </div>
          <!-- bar chart -->
          <div
            style="
              position: relative;
              z-index: 1;
              background: rgba(255, 255, 255, 0.04);
              border: 1px solid rgba(255, 255, 255, 0.06);
              border-radius: 12px;
              padding: 12px;
              flex: 1;
              display: grid;
              grid-template-rows: auto 1fr;
            "
          >
            <div
              style="
                display: flex;
                justify-content: space-between;
                font-family: var(--ff-mono);
                font-size: 9.5px;
                color: rgba(232, 240, 235, 0.55);
                letter-spacing: 0.06em;
                text-transform: uppercase;
                margin-bottom: 8px;
              "
            >
              <span>SO'NGGI 7 KUN</span>
              <span style="color: #86d4af">● TOSHKENT · SAMARQAND · BUXORO</span>
            </div>
            <div
              style="
                display: flex;
                align-items: flex-end;
                gap: 4px;
                height: 110px;
                padding-top: 6px;
              "
            >
              @for (h of barsHeights(bars7); track $index; let i = $index) {
                <div
                  [style.flex]="'1'"
                  [style.height.%]="h"
                  [style.background]="i === bars7.length - 1 ? '#86d4af' : '#86d4af55'"
                  style="border-radius: 3px 3px 0 0; min-height: 4px"
                ></div>
              }
            </div>
          </div>
          <!-- cities -->
          <div
            style="
              position: relative;
              z-index: 1;
              display: grid;
              grid-template-columns: 1fr 1fr 1fr;
              gap: 8px;
            "
          >
            @for (
              row of [
                ['Toshkent', 'UZS 1.84M'],
                ['Samarqand', 'UZS 1.42M'],
                ['Buxoro', 'UZS 0.94M'],
              ];
              track row[0]
            ) {
              <div
                style="
                  background: rgba(255, 255, 255, 0.04);
                  border: 1px solid rgba(255, 255, 255, 0.06);
                  border-radius: 10px;
                  padding: 8px 10px;
                "
              >
                <div
                  style="
                    font-size: 9.5px;
                    font-family: var(--ff-mono);
                    color: rgba(232, 240, 235, 0.5);
                    text-transform: uppercase;
                    letter-spacing: 0.06em;
                  "
                >
                  {{ row[0] }}
                </div>
                <div
                  style="
                    font-size: 14px;
                    font-weight: 700;
                    font-family: var(--ff-mono);
                    margin-top: 2px;
                  "
                >
                  {{ row[1] }}
                </div>
              </div>
            }
          </div>
        </div>

        <!-- Floating widgets -->
        <div class="widget widget--lag1" style="top: 10px; right: -10px; width: 220px">
          <div class="widget__label">Faol filiallar</div>
          <div class="widget__val">12 / 12</div>
          <div class="widget__delta">
            <span
              style="
                width: 6px;
                height: 6px;
                border-radius: 999px;
                background: var(--emerald);
                box-shadow: 0 0 8px var(--emerald-glow);
                display: inline-block;
              "
            ></span>
            Hammasi sinxron
          </div>
        </div>

        <div class="widget widget--lag2" style="bottom: 80px; left: -20px; width: 220px">
          <div class="widget__label">Bugungi davomat</div>
          <div style="display: flex; align-items: center; gap: 12px">
            <svg width="56" height="56" viewBox="0 0 84 84">
              <circle cx="42" cy="42" r="32" fill="none" stroke="#e8ece6" stroke-width="8" />
              <circle
                cx="42"
                cy="42"
                r="32"
                fill="none"
                stroke="#1f9d6a"
                stroke-width="8"
                stroke-linecap="round"
                [attr.stroke-dasharray]="donutCircumference"
                [attr.stroke-dashoffset]="donutOffset(92)"
                transform="rotate(-90 42 42)"
              />
              <text
                x="42"
                y="46"
                text-anchor="middle"
                font-size="16"
                font-weight="700"
                font-family="Manrope"
                fill="#0a1410"
              >
                92%
              </text>
            </svg>
            <div>
              <div style="font-size: 13px; font-weight: 700; letter-spacing: -0.01em">
                47 / 51 xodim
              </div>
              <div style="font-size: 10.5px; color: var(--muted); margin-top: 2px">
                4 ta kasallikda
              </div>
            </div>
          </div>
        </div>

        <div class="widget widget--lag3" style="bottom: -10px; right: 10px; width: 230px">
          <div class="widget__label">Umumiy ombor</div>
          <div class="widget__val">12,408</div>
          <svg
            [attr.viewBox]="'0 0 240 32'"
            preserveAspectRatio="none"
            style="width: 100%; height: 32px; margin-top: 8px"
          >
            <path [attr.d]="sparkArea(spark14, 32)" fill="url(#sg-green)" />
            <polyline
              [attr.points]="sparkPoints(spark14, 32)"
              fill="none"
              stroke="#1f9d6a"
              stroke-width="1.6"
              stroke-linejoin="round"
              stroke-linecap="round"
            />
          </svg>
        </div>
      </div>
    </div>
  </header>

  <!-- ════════════════ MACBOOK SCENE ════════════════ -->
  <section class="scene" id="modules">
    <div class="scene__sticky" [class.is-open]="macOpen()">
      <div class="scene__bg"></div>
      <div class="particles">
        @for (p of sceneParticles; track p.left) {
          <span
            class="particle"
            [style.left]="p.left"
            [style.bottom]="p.bottom"
            [style.animationDuration]="p.duration + 's'"
            [style.animationDelay]="p.delay + 's'"
            [style.transform]="'scale(' + p.scale + ')'"
          ></span>
        }
      </div>

      <!-- Heading -->
      <div class="scene__heading">
        <span class="eyebrow">{{ 'LANDING.MODULES.EYEBROW' | translate }}</span>
        <div class="scene__title__wrap">
          @for (m of moduleItems; track m.id; let i = $index) {
            <h2 class="scene__title" [class.is-on]="activeModule() === i">{{ m.title }}</h2>
          }
        </div>
        <div class="scene__sub__wrap">
          @for (m of moduleItems; track m.id; let i = $index) {
            <p class="scene__sub" [class.is-on]="activeModule() === i">{{ m.sub }}</p>
          }
        </div>
      </div>

      <!-- MacBook -->
      <div class="mb" [class.is-open]="macOpen()">
        <div class="mb__shadow"></div>
        <div class="mb__lid">
          <div class="mb__notch"></div>
          <div class="mb__screen">
            <div class="mb__screen-inner">
              <!-- ── MODULE 0: POS ── -->
              <div class="mod-slide" [class.is-active]="activeModule() === 0">
                <div class="mod">
                  <div class="mod__chrome">
                    <span class="dot r"></span><span class="dot y"></span><span class="dot g"></span
                    ><span class="url">miyzan.app / pos</span>
                  </div>
                  <div class="mod__body">
                    <nav class="mod__nav">
                      <div class="mod__nav__brand"><span class="m"></span>Miyzan</div>
                      <div class="mod__nav__group">Operate</div>
                      <div class="mod__nav__item is-on"><span class="ico"></span>POS Terminal</div>
                      <div class="mod__nav__item"><span class="ico"></span>Warehouse</div>
                      <div class="mod__nav__item"><span class="ico"></span>Employees</div>
                      <div class="mod__nav__item"><span class="ico"></span>Debt Ledger</div>
                      <div class="mod__nav__group">Insight</div>
                      <div class="mod__nav__item"><span class="ico"></span>Analytics</div>
                      <div class="mod__nav__item"><span class="ico"></span>Reports</div>
                      <div class="mod__nav__item"><span class="ico"></span>Live Monitor</div>
                    </nav>
                    <div
                      class="mod__main"
                      style="
                        background: #fbfcfa;
                        display: grid;
                        grid-template-columns: 1.2fr 0.8fr;
                        gap: 12px;
                      "
                    >
                      <div>
                        <div class="mod__hdr">
                          <h4>Register #2 · Cashier Aziza</h4>
                          <span class="meta">14:08 · TX 8442</span>
                        </div>
                        <div style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 6px">
                          @for (
                            p of [
                              'Espresso',
                              'Latte',
                              'Cappuccino',
                              'Cortado',
                              'Mocha',
                              'Americano',
                              'Macchiato',
                              'Flat White',
                              'Cold Brew',
                              'Matcha',
                              'Croissant',
                              'Choco Bun',
                            ];
                            track p;
                            let i = $index
                          ) {
                            <div
                              [style.background]="i === 2 ? '#e6f4ec' : 'white'"
                              [style.border]="
                                i === 2 ? '1px solid #1f9d6a' : '1px solid rgba(10,30,22,0.06)'
                              "
                              style="
                                border-radius: 8px;
                                padding: 8px;
                                font-size: 10px;
                                font-weight: 600;
                                min-height: 56px;
                                display: flex;
                                flex-direction: column;
                                justify-content: space-between;
                              "
                            >
                              <div
                                [style.background]="'oklch(0.9 0.04 ' + (100 + i * 15) + ')'"
                                style="width: 22px; height: 22px; border-radius: 6px"
                              ></div>
                              <div>
                                <div>{{ p }}</div>
                                <div
                                  style="
                                    color: #5a6a63;
                                    font-family: var(--ff-mono);
                                    font-size: 9px;
                                  "
                                >
                                  {{ (8 + i * 0.4).toFixed(2) }}
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                      <div
                        style="
                          background: white;
                          border: 1px solid rgba(10, 30, 22, 0.06);
                          border-radius: 10px;
                          padding: 12px;
                          display: flex;
                          flex-direction: column;
                        "
                      >
                        <div style="font-size: 11px; font-weight: 700; margin-bottom: 8px">
                          Cart · 3 items
                        </div>
                        @for (
                          r of [
                            ['Cappuccino', 'x1', '9.40'],
                            ['Croissant', 'x2', '11.00'],
                            ['Latte', 'x1', '9.80'],
                          ];
                          track r[0]
                        ) {
                          <div
                            style="
                              display: flex;
                              justify-content: space-between;
                              padding: 6px 0;
                              border-bottom: 1px solid rgba(10, 30, 22, 0.04);
                              font-size: 10.5px;
                            "
                          >
                            <span>{{ r[0] }}</span
                            ><span style="color: #5a6a63">{{ r[1] }}</span
                            ><span style="font-family: var(--ff-mono)">{{ r[2] }}</span>
                          </div>
                        }
                        <div style="margin-top: auto; padding-top: 10px">
                          <div
                            style="
                              display: flex;
                              justify-content: space-between;
                              font-size: 10px;
                              color: #5a6a63;
                            "
                          >
                            <span>Subtotal</span
                            ><span style="font-family: var(--ff-mono)">30.20</span>
                          </div>
                          <div
                            style="
                              display: flex;
                              justify-content: space-between;
                              font-size: 10px;
                              color: #5a6a63;
                              margin: 3px 0;
                            "
                          >
                            <span>VAT 12%</span
                            ><span style="font-family: var(--ff-mono)">3.62</span>
                          </div>
                          <div
                            style="
                              display: flex;
                              justify-content: space-between;
                              font-size: 16px;
                              font-weight: 800;
                              letter-spacing: -0.02em;
                              margin-top: 6px;
                            "
                          >
                            <span>Total</span><span style="font-family: var(--ff-mono)">33.82</span>
                          </div>
                          <button
                            style="
                              width: 100%;
                              margin-top: 10px;
                              padding: 10px 12px;
                              border-radius: 8px;
                              background: linear-gradient(180deg, #2cb87d, #178654);
                              color: white;
                              border: none;
                              font-weight: 700;
                              font-size: 12px;
                              box-shadow: 0 8px 20px -6px rgba(40, 160, 110, 0.5);
                            "
                          >
                            Charge 33.82
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- ── MODULE 1: Warehouse ── -->
              <div class="mod-slide" [class.is-active]="activeModule() === 1">
                <div class="mod">
                  <div class="mod__chrome">
                    <span class="dot r"></span><span class="dot y"></span><span class="dot g"></span
                    ><span class="url">miyzan.app / warehouse</span>
                  </div>
                  <div class="mod__body">
                    <nav class="mod__nav">
                      <div class="mod__nav__brand"><span class="m"></span>Miyzan</div>
                      <div class="mod__nav__group">Operate</div>
                      <div class="mod__nav__item"><span class="ico"></span>POS Terminal</div>
                      <div class="mod__nav__item is-on"><span class="ico"></span>Warehouse</div>
                      <div class="mod__nav__item"><span class="ico"></span>Employees</div>
                      <div class="mod__nav__item"><span class="ico"></span>Debt Ledger</div>
                      <div class="mod__nav__group">Insight</div>
                      <div class="mod__nav__item"><span class="ico"></span>Analytics</div>
                      <div class="mod__nav__item"><span class="ico"></span>Reports</div>
                      <div class="mod__nav__item"><span class="ico"></span>Live Monitor</div>
                    </nav>
                    <div class="mod__main">
                      <div class="mod__hdr">
                        <h4>Warehouse · 3 locations</h4>
                        <span class="meta">Last sync 12s ago</span>
                      </div>
                      <div class="kpi-row">
                        <div class="kpi">
                          <div class="kpi__l">SKUs</div>
                          <div class="kpi__v">12,408</div>
                          <div class="kpi__d">+184 this week</div>
                        </div>
                        <div class="kpi">
                          <div class="kpi__l">Low stock</div>
                          <div class="kpi__v" style="color: #d97757">27</div>
                          <div class="kpi__d" style="color: #d97757">Auto-reorder armed</div>
                        </div>
                        <div class="kpi">
                          <div class="kpi__l">In transit</div>
                          <div class="kpi__v">142</div>
                          <div class="kpi__d">3 shipments</div>
                        </div>
                        <div class="kpi">
                          <div class="kpi__l">Value held</div>
                          <div class="kpi__v">UZS 8.42M</div>
                          <div class="kpi__d">+2.1%</div>
                        </div>
                      </div>
                      <div
                        style="
                          background: #fbfcfa;
                          border: 1px solid rgba(10, 30, 22, 0.06);
                          border-radius: 10px;
                          overflow: hidden;
                        "
                      >
                        <div
                          style="
                            display: grid;
                            grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
                            padding: 8px 12px;
                            background: #f3f6f0;
                            font-size: 9px;
                            font-family: var(--ff-mono);
                            text-transform: uppercase;
                            letter-spacing: 0.06em;
                            color: #5a6a63;
                          "
                        >
                          <span>Item</span><span>SKU</span><span>Tashkent</span
                          ><span>Samarkand</span><span>Status</span>
                        </div>
                        @for (
                          r of [
                            ['Arabica beans 1kg', 'BN-1041', 124, 22, 'ok'],
                            ['Oat milk 1L', 'OM-2018', 8, 0, 'low'],
                            ['Vanilla syrup', 'SY-3300', 56, 18, 'ok'],
                            ['Paper cups 12oz', 'CP-4112', 1240, 380, 'ok'],
                            ['Espresso filter', 'FL-5021', 12, 4, 'low'],
                          ];
                          track r[0]
                        ) {
                          <div
                            style="
                              display: grid;
                              grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
                              padding: 8px 12px;
                              border-top: 1px solid rgba(10, 30, 22, 0.04);
                              font-size: 10.5px;
                              align-items: center;
                            "
                          >
                            <span style="font-weight: 600">{{ r[0] }}</span>
                            <span style="font-family: var(--ff-mono); color: #5a6a63">{{
                              r[1]
                            }}</span>
                            <span style="font-family: var(--ff-mono)">{{ r[2] }}</span>
                            <span style="font-family: var(--ff-mono)">{{ r[3] }}</span>
                            <span
                              [style.background]="r[4] === 'ok' ? '#e6f4ec' : '#fbe5dd'"
                              [style.color]="r[4] === 'ok' ? '#178654' : '#a8462e'"
                              style="
                                display: inline-flex;
                                padding: 2px 8px;
                                border-radius: 999px;
                                font-size: 9px;
                                font-weight: 600;
                                width: fit-content;
                              "
                              >{{ r[4] === 'ok' ? 'In stock' : 'Low stock' }}</span
                            >
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- ── MODULE 2: Employees ── -->
              <div class="mod-slide" [class.is-active]="activeModule() === 2">
                <div class="mod">
                  <div class="mod__chrome">
                    <span class="dot r"></span><span class="dot y"></span><span class="dot g"></span
                    ><span class="url">miyzan.app / team</span>
                  </div>
                  <div class="mod__body">
                    <nav class="mod__nav">
                      <div class="mod__nav__brand"><span class="m"></span>Miyzan</div>
                      <div class="mod__nav__group">Operate</div>
                      <div class="mod__nav__item"><span class="ico"></span>POS Terminal</div>
                      <div class="mod__nav__item"><span class="ico"></span>Warehouse</div>
                      <div class="mod__nav__item is-on"><span class="ico"></span>Employees</div>
                      <div class="mod__nav__item"><span class="ico"></span>Debt Ledger</div>
                      <div class="mod__nav__group">Insight</div>
                      <div class="mod__nav__item"><span class="ico"></span>Analytics</div>
                      <div class="mod__nav__item"><span class="ico"></span>Reports</div>
                      <div class="mod__nav__item"><span class="ico"></span>Live Monitor</div>
                    </nav>
                    <div class="mod__main">
                      <div class="mod__hdr">
                        <h4>Xodimlar · Davomat va samaradorlik</h4>
                        <span class="meta">51 xodim · 3 smena</span>
                      </div>
                      <div class="kpi-row">
                        <div class="kpi">
                          <div class="kpi__l">Hozir ishda</div>
                          <div class="kpi__v">47 / 51</div>
                          <div class="kpi__d">▲ 92% davomat</div>
                        </div>
                        <div class="kpi">
                          <div class="kpi__l">Kech kelganlar</div>
                          <div class="kpi__v" style="color: #d97757">3</div>
                          <div class="kpi__d" style="color: #d97757">
                            2 kechikish bildirishnomasi
                          </div>
                        </div>
                        <div class="kpi">
                          <div class="kpi__l">O'rtacha smena</div>
                          <div class="kpi__v">7s 42d</div>
                          <div class="kpi__d">Maqsadga muvofiq</div>
                        </div>
                        <div class="kpi">
                          <div class="kpi__l">Oylik · MTD</div>
                          <div class="kpi__v">UZS 4.62M</div>
                          <div class="kpi__d">Avto-hisoblangan</div>
                        </div>
                      </div>
                      <div
                        style="
                          background: #fbfcfa;
                          border: 1px solid rgba(10, 30, 22, 0.06);
                          border-radius: 10px;
                          overflow: hidden;
                        "
                      >
                        <div
                          style="
                            display: grid;
                            grid-template-columns: 34px 1.4fr 0.8fr 0.8fr 0.6fr 0.7fr;
                            padding: 8px 12px;
                            background: #f3f6f0;
                            font-size: 9px;
                            font-family: var(--ff-mono);
                            text-transform: uppercase;
                            letter-spacing: 0.06em;
                            color: #5a6a63;
                          "
                        >
                          <span></span><span>Xodim</span><span>Kelgan</span><span>Tx</span
                          ><span>Aylanma</span><span>Holat</span>
                        </div>
                        @for (
                          r of [
                            ['A', 'Aziza T.', 'Kassir · #2', '08:58', 42, 'UZS 1.84M', 'ok'],
                            ['B', 'Bobur S.', 'Kassir · #1', '08:55', 38, 'UZS 1.62M', 'ok'],
                            ['L', 'Lola K.', 'Barista', '09:02', 31, 'UZS 1.21M', 'ok'],
                            ['D', 'Davron M.', 'Kassir · #3', '09:14', 28, 'UZS 0.98M', 'late'],
                            ['M', 'Madina Z.', 'Barista', '—', 0, '—', 'absent'],
                          ];
                          track r[1];
                          let i = $index
                        ) {
                          <div
                            style="
                              display: grid;
                              grid-template-columns: 34px 1.4fr 0.8fr 0.8fr 0.6fr 0.7fr;
                              gap: 6px;
                              padding: 8px 12px;
                              border-top: 1px solid rgba(10, 30, 22, 0.04);
                              align-items: center;
                              font-size: 10.5px;
                            "
                          >
                            <div
                              [style.background]="'oklch(0.85 0.05 ' + (120 + i * 30) + ')'"
                              style="
                                width: 26px;
                                height: 26px;
                                border-radius: 999px;
                                display: grid;
                                place-items: center;
                                font-weight: 700;
                                font-size: 11px;
                                color: #0a1410;
                              "
                            >
                              {{ r[0] }}
                            </div>
                            <div>
                              <div style="font-weight: 600">{{ r[1] }}</div>
                              <div style="color: #5a6a63; font-size: 9px">{{ r[2] }}</div>
                            </div>
                            <span
                              [style.color]="
                                r[6] === 'late'
                                  ? '#d97757'
                                  : r[6] === 'absent'
                                    ? '#a8462e'
                                    : '#5a6a63'
                              "
                              style="font-family: var(--ff-mono)"
                              >{{ r[3] }}</span
                            >
                            <span style="font-family: var(--ff-mono)">{{ r[4] }} tx</span>
                            <span style="font-family: var(--ff-mono); font-weight: 600">{{
                              r[5]
                            }}</span>
                            <span
                              [style.background]="
                                r[6] === 'ok' ? '#e6f4ec' : r[6] === 'late' ? '#fcefd6' : '#fbe5dd'
                              "
                              [style.color]="
                                r[6] === 'ok' ? '#178654' : r[6] === 'late' ? '#a87a1a' : '#a8462e'
                              "
                              style="
                                display: inline-flex;
                                padding: 2px 8px;
                                border-radius: 999px;
                                font-size: 9px;
                                font-weight: 600;
                                width: fit-content;
                              "
                              >{{
                                r[6] === 'ok' ? 'Ishda' : r[6] === 'late' ? 'Kech' : "Yo'q"
                              }}</span
                            >
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- ── MODULE 3: Analytics ── -->
              <div class="mod-slide" [class.is-active]="activeModule() === 3">
                <div class="mod">
                  <div class="mod__chrome">
                    <span class="dot r"></span><span class="dot y"></span><span class="dot g"></span
                    ><span class="url">miyzan.app / analytics</span>
                  </div>
                  <div class="mod__body">
                    <nav class="mod__nav">
                      <div class="mod__nav__brand"><span class="m"></span>Miyzan</div>
                      <div class="mod__nav__group">Operate</div>
                      <div class="mod__nav__item"><span class="ico"></span>POS Terminal</div>
                      <div class="mod__nav__item"><span class="ico"></span>Warehouse</div>
                      <div class="mod__nav__item"><span class="ico"></span>Employees</div>
                      <div class="mod__nav__item"><span class="ico"></span>Debt Ledger</div>
                      <div class="mod__nav__group">Insight</div>
                      <div class="mod__nav__item is-on"><span class="ico"></span>Analytics</div>
                      <div class="mod__nav__item"><span class="ico"></span>Reports</div>
                      <div class="mod__nav__item"><span class="ico"></span>Live Monitor</div>
                    </nav>
                    <div class="mod__main">
                      <div class="mod__hdr">
                        <h4>Revenue · This quarter</h4>
                        <span class="meta">Q2 2026 · Live</span>
                      </div>
                      <div class="kpi-row" style="grid-template-columns: repeat(3, 1fr) 1.4fr">
                        <div class="kpi">
                          <div class="kpi__l">Revenue</div>
                          <div class="kpi__v">UZS 142.8M</div>
                          <div class="kpi__d">+38.4% YoY</div>
                        </div>
                        <div class="kpi">
                          <div class="kpi__l">Orders</div>
                          <div class="kpi__v">48,212</div>
                          <div class="kpi__d">+12.1%</div>
                        </div>
                        <div class="kpi">
                          <div class="kpi__l">Avg ticket</div>
                          <div class="kpi__v">UZS 2,962</div>
                          <div class="kpi__d">+5.6%</div>
                        </div>
                        <div class="kpi" style="display: flex; align-items: center; gap: 12px">
                          <svg width="62" height="62" viewBox="0 0 84 84">
                            <circle
                              cx="42"
                              cy="42"
                              r="32"
                              fill="none"
                              stroke="#e8ece6"
                              stroke-width="8"
                            />
                            <circle
                              cx="42"
                              cy="42"
                              r="32"
                              fill="none"
                              stroke="#1f9d6a"
                              stroke-width="8"
                              stroke-linecap="round"
                              [attr.stroke-dasharray]="donutCircumference"
                              [attr.stroke-dashoffset]="donutOffset(78)"
                              transform="rotate(-90 42 42)"
                            />
                            <text
                              x="42"
                              y="46"
                              text-anchor="middle"
                              font-size="16"
                              font-weight="700"
                              font-family="Manrope"
                              fill="#0a1410"
                            >
                              78%
                            </text>
                          </svg>
                          <div>
                            <div class="kpi__l">Margin</div>
                            <div style="font-size: 12px; font-weight: 600">Gross 78%</div>
                            <div style="font-size: 10px; color: #5a6a63">vs target 72%</div>
                          </div>
                        </div>
                      </div>
                      <div
                        style="
                          background: #fbfcfa;
                          border: 1px solid rgba(10, 30, 22, 0.06);
                          border-radius: 10px;
                          padding: 14px;
                          height: 200px;
                        "
                      >
                        <div
                          style="
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            margin-bottom: 10px;
                          "
                        >
                          <div style="font-size: 11px; font-weight: 700">
                            Daily revenue · last 30 days
                          </div>
                        </div>
                        <div
                          style="
                            display: flex;
                            align-items: flex-end;
                            gap: 2px;
                            height: 140px;
                            padding-top: 6px;
                          "
                        >
                          @for (h of barsHeights(analytics30); track $index; let i = $index) {
                            <div
                              [style.flex]="'1'"
                              [style.height.%]="h"
                              [style.background]="
                                i === analytics30.length - 1 ? '#1f9d6a' : '#1f9d6a55'
                              "
                              style="border-radius: 3px 3px 0 0; min-height: 2px"
                            ></div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- ── MODULE 4: Debt ── -->
              <div class="mod-slide" [class.is-active]="activeModule() === 4">
                <div class="mod">
                  <div class="mod__chrome">
                    <span class="dot r"></span><span class="dot y"></span><span class="dot g"></span
                    ><span class="url">miyzan.app / debt</span>
                  </div>
                  <div class="mod__body">
                    <nav class="mod__nav">
                      <div class="mod__nav__brand"><span class="m"></span>Miyzan</div>
                      <div class="mod__nav__group">Operate</div>
                      <div class="mod__nav__item"><span class="ico"></span>POS Terminal</div>
                      <div class="mod__nav__item"><span class="ico"></span>Warehouse</div>
                      <div class="mod__nav__item"><span class="ico"></span>Employees</div>
                      <div class="mod__nav__item is-on"><span class="ico"></span>Debt Ledger</div>
                      <div class="mod__nav__group">Insight</div>
                      <div class="mod__nav__item"><span class="ico"></span>Analytics</div>
                      <div class="mod__nav__item"><span class="ico"></span>Reports</div>
                      <div class="mod__nav__item"><span class="ico"></span>Live Monitor</div>
                    </nav>
                    <div class="mod__main">
                      <div class="mod__hdr">
                        <h4>Debt ledger · Customers</h4>
                        <span class="meta">38 open · UZS 12.4M outstanding</span>
                      </div>
                      <div class="kpi-row">
                        <div class="kpi">
                          <div class="kpi__l">Receivable</div>
                          <div class="kpi__v">UZS 12.4M</div>
                          <div class="kpi__d">38 customers</div>
                        </div>
                        <div class="kpi">
                          <div class="kpi__l">Due this week</div>
                          <div class="kpi__v" style="color: #d97757">UZS 2.1M</div>
                          <div class="kpi__d" style="color: #d97757">8 overdue</div>
                        </div>
                        <div class="kpi">
                          <div class="kpi__l">Collected · MTD</div>
                          <div class="kpi__v">UZS 9.8M</div>
                          <div class="kpi__d">+22%</div>
                        </div>
                        <div class="kpi">
                          <div class="kpi__l">Recovery rate</div>
                          <div class="kpi__v">94.2%</div>
                          <div class="kpi__d">on target</div>
                        </div>
                      </div>
                      <div
                        style="
                          background: #fbfcfa;
                          border: 1px solid rgba(10, 30, 22, 0.06);
                          border-radius: 10px;
                          overflow: hidden;
                        "
                      >
                        <div
                          style="
                            display: grid;
                            grid-template-columns: 1.4fr 1fr 1fr 1fr 0.8fr;
                            padding: 8px 12px;
                            background: #f3f6f0;
                            font-size: 9px;
                            font-family: var(--ff-mono);
                            text-transform: uppercase;
                            letter-spacing: 0.06em;
                            color: #5a6a63;
                          "
                        >
                          <span>Customer</span><span>Issued</span><span>Due</span><span>Amount</span
                          ><span>Status</span>
                        </div>
                        @for (
                          r of [
                            ['Khurshid LLC', '12 Mar', '30 Apr', 'UZS 1.84M', 'overdue'],
                            ['Cafe Magnolia', '02 Apr', '20 May', 'UZS 0.62M', 'due soon'],
                            ['Bobur Holdings', '18 Apr', '18 Jun', 'UZS 2.40M', 'on track'],
                            ["Najot Ta'lim", '22 Apr', '22 Jun', 'UZS 0.94M', 'on track'],
                            ['Restoran Karavan', '04 May', '04 Jul', 'UZS 1.21M', 'on track'],
                          ];
                          track r[0]
                        ) {
                          <div
                            style="
                              display: grid;
                              grid-template-columns: 1.4fr 1fr 1fr 1fr 0.8fr;
                              padding: 8px 12px;
                              border-top: 1px solid rgba(10, 30, 22, 0.04);
                              font-size: 10.5px;
                              align-items: center;
                            "
                          >
                            <span style="font-weight: 600">{{ r[0] }}</span>
                            <span style="font-family: var(--ff-mono); color: #5a6a63">{{
                              r[1]
                            }}</span>
                            <span style="font-family: var(--ff-mono); color: #5a6a63">{{
                              r[2]
                            }}</span>
                            <span style="font-family: var(--ff-mono); font-weight: 600">{{
                              r[3]
                            }}</span>
                            <span
                              [style.background]="
                                r[4] === 'overdue'
                                  ? '#fbe5dd'
                                  : r[4] === 'due soon'
                                    ? '#fcefd6'
                                    : '#e6f4ec'
                              "
                              [style.color]="
                                r[4] === 'overdue'
                                  ? '#a8462e'
                                  : r[4] === 'due soon'
                                    ? '#a87a1a'
                                    : '#178654'
                              "
                              style="
                                display: inline-flex;
                                padding: 2px 8px;
                                border-radius: 999px;
                                font-size: 9px;
                                font-weight: 600;
                                width: fit-content;
                              "
                              >{{ r[4] }}</span
                            >
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- ── MODULE 5: Reports ── -->
              <div class="mod-slide" [class.is-active]="activeModule() === 5">
                <div class="mod">
                  <div class="mod__chrome">
                    <span class="dot r"></span><span class="dot y"></span><span class="dot g"></span
                    ><span class="url">miyzan.app / reports</span>
                  </div>
                  <div class="mod__body">
                    <nav class="mod__nav">
                      <div class="mod__nav__brand"><span class="m"></span>Miyzan</div>
                      <div class="mod__nav__group">Operate</div>
                      <div class="mod__nav__item"><span class="ico"></span>POS Terminal</div>
                      <div class="mod__nav__item"><span class="ico"></span>Warehouse</div>
                      <div class="mod__nav__item"><span class="ico"></span>Employees</div>
                      <div class="mod__nav__item"><span class="ico"></span>Debt Ledger</div>
                      <div class="mod__nav__group">Insight</div>
                      <div class="mod__nav__item"><span class="ico"></span>Analytics</div>
                      <div class="mod__nav__item is-on"><span class="ico"></span>Reports</div>
                      <div class="mod__nav__item"><span class="ico"></span>Live Monitor</div>
                    </nav>
                    <div class="mod__main">
                      <div class="mod__hdr">
                        <h4>Reports library</h4>
                        <span class="meta">Scheduled · 24 active</span>
                      </div>
                      <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px">
                        @for (r of repReports; track r.t) {
                          <div
                            style="
                              background: #fbfcfa;
                              border: 1px solid rgba(10, 30, 22, 0.06);
                              border-radius: 10px;
                              padding: 12px;
                            "
                          >
                            <div
                              style="
                                display: flex;
                                justify-content: space-between;
                                align-items: flex-start;
                              "
                            >
                              <div>
                                <div
                                  style="font-size: 12px; font-weight: 700; letter-spacing: -0.01em"
                                >
                                  {{ r.t }}
                                </div>
                                <div style="font-size: 9.5px; color: #5a6a63; margin-top: 2px">
                                  {{ r.s }}
                                </div>
                              </div>
                              <span
                                style="
                                  font-size: 8px;
                                  font-family: var(--ff-mono);
                                  color: #178654;
                                  background: #e6f4ec;
                                  padding: 2px 6px;
                                  border-radius: 999px;
                                  font-weight: 600;
                                "
                                >LIVE</span
                              >
                            </div>
                            <div style="margin-top: 8px">
                              <svg
                                [attr.viewBox]="'0 0 240 40'"
                                preserveAspectRatio="none"
                                style="width: 100%; height: 40px"
                              >
                                <path [attr.d]="sparkArea(r.d, 40)" fill="url(#sg-green)" />
                                <polyline
                                  [attr.points]="sparkPoints(r.d, 40)"
                                  fill="none"
                                  stroke="#1f9d6a"
                                  stroke-width="1.6"
                                  stroke-linejoin="round"
                                  stroke-linecap="round"
                                />
                              </svg>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- ── MODULE 6: Live Monitor ── -->
              <div class="mod-slide" [class.is-active]="activeModule() === 6">
                <div class="mod">
                  <div class="mod__chrome">
                    <span class="dot r"></span><span class="dot y"></span><span class="dot g"></span
                    ><span class="url">miyzan.app / live</span>
                  </div>
                  <div class="mod__body">
                    <nav class="mod__nav">
                      <div class="mod__nav__brand"><span class="m"></span>Miyzan</div>
                      <div class="mod__nav__group">Operate</div>
                      <div class="mod__nav__item"><span class="ico"></span>POS Terminal</div>
                      <div class="mod__nav__item"><span class="ico"></span>Warehouse</div>
                      <div class="mod__nav__item"><span class="ico"></span>Employees</div>
                      <div class="mod__nav__item"><span class="ico"></span>Debt Ledger</div>
                      <div class="mod__nav__group">Insight</div>
                      <div class="mod__nav__item"><span class="ico"></span>Analytics</div>
                      <div class="mod__nav__item"><span class="ico"></span>Reports</div>
                      <div class="mod__nav__item is-on"><span class="ico"></span>Live Monitor</div>
                    </nav>
                    <div
                      class="mod__main"
                      style="background: linear-gradient(180deg, #0d1814, #08110d); color: #e8f0eb"
                    >
                      <div class="mod__hdr">
                        <h4 style="color: white">Live monitor · all locations</h4>
                        <span class="meta" style="color: #86d4af">● Streaming</span>
                      </div>
                      <div
                        style="
                          display: grid;
                          grid-template-columns: repeat(3, 1fr);
                          gap: 8px;
                          margin-bottom: 10px;
                        "
                      >
                        @for (
                          r of [
                            ['Tashkent · Main', '12 active', 'UZS 482K'],
                            ['Samarkand', '8 active', 'UZS 218K'],
                            ['Bukhara', '5 active', 'UZS 142K'],
                          ];
                          track r[0]
                        ) {
                          <div
                            style="
                              background: rgba(255, 255, 255, 0.04);
                              border: 1px solid rgba(255, 255, 255, 0.08);
                              border-radius: 10px;
                              padding: 10px;
                            "
                          >
                            <div
                              style="
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                              "
                            >
                              <span style="font-size: 10.5px; font-weight: 600">{{ r[0] }}</span
                              ><span
                                style="
                                  width: 6px;
                                  height: 6px;
                                  border-radius: 999px;
                                  background: #86d4af;
                                  box-shadow: 0 0 8px #86d4af;
                                  display: inline-block;
                                "
                              ></span>
                            </div>
                            <div
                              style="
                                font-size: 9px;
                                color: rgba(232, 240, 235, 0.6);
                                margin-top: 2px;
                              "
                            >
                              {{ r[1] }} terminals
                            </div>
                            <div
                              style="
                                font-size: 18px;
                                font-weight: 700;
                                margin-top: 4px;
                                font-family: var(--ff-mono);
                              "
                            >
                              {{ r[2] }}
                            </div>
                          </div>
                        }
                      </div>
                      <div
                        style="
                          background: rgba(255, 255, 255, 0.04);
                          border: 1px solid rgba(255, 255, 255, 0.08);
                          border-radius: 10px;
                          padding: 12px;
                        "
                      >
                        <div
                          style="display: flex; justify-content: space-between; margin-bottom: 8px"
                        >
                          <span style="font-size: 11px; font-weight: 700">Live transactions</span
                          ><span style="font-size: 9px; color: #86d4af; font-family: var(--ff-mono)"
                            >refresh 1s</span
                          >
                        </div>
                        @for (
                          r of [
                            [
                              '14:08:42',
                              'TASH-02',
                              'Cappuccino ×1 · Croissant ×2',
                              'UZS 38,400',
                              'Card',
                            ],
                            ['14:08:38', 'SAMK-01', 'Latte ×2', 'UZS 24,800', 'Cash'],
                            ['14:08:33', 'TASH-01', 'Family pack', 'UZS 184,200', 'Card'],
                            ['14:08:29', 'BUKH-01', 'Espresso ×1', 'UZS 9,200', 'Apple Pay'],
                            ['14:08:24', 'TASH-02', 'Combo deal ×3', 'UZS 72,600', 'Card'],
                          ];
                          track r[0];
                          let i = $index
                        ) {
                          <div
                            [style.borderTop]="i ? '1px solid rgba(255,255,255,0.05)' : 'none'"
                            style="
                              display: grid;
                              grid-template-columns: 70px 70px 1fr 80px 80px;
                              gap: 8px;
                              padding: 6px 0;
                              font-size: 10px;
                            "
                          >
                            <span style="font-family: var(--ff-mono); color: #86d4af">{{
                              r[0]
                            }}</span>
                            <span
                              style="font-family: var(--ff-mono); color: rgba(232, 240, 235, 0.6)"
                              >{{ r[1] }}</span
                            >
                            <span>{{ r[2] }}</span>
                            <span
                              style="
                                font-family: var(--ff-mono);
                                font-weight: 700;
                                text-align: right;
                              "
                              >{{ r[3] }}</span
                            >
                            <span style="color: rgba(232, 240, 235, 0.6); text-align: right">{{
                              r[4]
                            }}</span>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /mb__screen-inner -->
            <div class="mb__reflection"></div>
          </div>
          <!-- /mb__screen -->
        </div>
        <!-- /mb__lid -->
        <div class="mb__base"></div>
      </div>
      <!-- /mb -->

      <!-- Floating cards beside MacBook -->
      <div class="scene__float" style="top: 20%; left: 5%">
        <div class="widget__label">{{ 'LANDING.MODULES.FLOAT_SYNC_LABEL' | translate }}</div>
        <div style="display: flex; align-items: center; gap: 8px; margin-top: 4px">
          <span
            style="
              width: 8px;
              height: 8px;
              border-radius: 999px;
              background: var(--emerald);
              box-shadow: 0 0 8px var(--emerald-glow);
              display: inline-block;
            "
          ></span>
          <span style="font-size: 13px; font-weight: 600">{{
            'LANDING.MODULES.FLOAT_SYNC_VALUE' | translate
          }}</span>
        </div>
        <div
          style="font-size: 11px; color: var(--muted); margin-top: 4px; font-family: var(--ff-mono)"
        >
          {{ 'LANDING.MODULES.FLOAT_SYNC_SUB' | translate }}
        </div>
      </div>
      <div class="scene__float" style="top: 26%; right: 5%">
        <div class="widget__label">{{ 'LANDING.MODULES.FLOAT_TODAY_LABEL' | translate }}</div>
        <div
          style="
            font-size: 22px;
            font-weight: 800;
            letter-spacing: -0.03em;
            margin-top: 4px;
            font-family: var(--ff-mono);
          "
        >
          +18.2%
        </div>
        <svg
          viewBox="0 0 240 28"
          preserveAspectRatio="none"
          style="width: 100%; height: 28px; margin-top: 4px"
        >
          <path [attr.d]="sparkArea(spark12, 28)" fill="url(#sg-green)" />
          <polyline
            [attr.points]="sparkPoints(spark12, 28)"
            fill="none"
            stroke="#1f9d6a"
            stroke-width="1.6"
            stroke-linejoin="round"
            stroke-linecap="round"
          />
        </svg>
      </div>
      <div class="scene__float" style="bottom: 22%; left: 7%; min-width: 200px">
        <div class="widget__label">{{ 'LANDING.MODULES.FLOAT_BEST_LABEL' | translate }}</div>
        <div style="font-size: 13px; font-weight: 700; margin-top: 4px; letter-spacing: -0.01em">
          {{ 'LANDING.MODULES.FLOAT_BEST_VALUE' | translate }}
        </div>
        <div style="font-size: 11px; color: var(--emerald-deep); margin-top: 4px; font-weight: 600">
          ▲ {{ 'LANDING.MODULES.FLOAT_BEST_SUB' | translate }}
        </div>
      </div>

      <!-- Module rail -->
      <div class="scene__rail">
        @for (m of moduleItems; track m.id; let i = $index) {
          <button
            class="scene__rail__dot"
            [class.active]="activeModule() === i"
            (click)="goto(i)"
            [attr.aria-label]="m.label + 'ga o\'tish'"
          ></button>
        }
        <span class="scene__rail__label">{{ moduleItems[activeModule()].label }}</span>
        <button class="scene__rail__next" (click)="nextModule()" aria-label="Keyingisi">→</button>
      </div>
    </div>
    <!-- /scene__sticky -->
  </section>

  <!-- ════════════════ FEATURES BENTO ════════════════ -->
  <section class="section" id="platform">
    <div class="wrap">
      <div class="section__head reveal">
        <span class="eyebrow">{{ 'LANDING.FEATURES.EYEBROW' | translate }}</span>
        <h2>{{ 'LANDING.FEATURES.TITLE' | translate }}</h2>
        <p>{{ 'LANDING.FEATURES.SUBTITLE' | translate }}</p>
      </div>
      <div class="bento">
        <!-- Tile 1: 4-col dark -->
        <div class="tile tile--span4 tile--dark reveal">
          <span class="eyebrow" style="color: #86d4af">{{
            'LANDING.FEATURES.TILE_REALTIME_EYEBROW' | translate
          }}</span>
          <h3 style="font-size: 32px; letter-spacing: -0.035em">
            {{ 'LANDING.FEATURES.TILE_REALTIME_TITLE' | translate }}
          </h3>
          <p>{{ 'LANDING.FEATURES.TILE_REALTIME_DESC' | translate }}</p>
          <div
            class="tile__art"
            style="
              background: radial-gradient(
                400px 200px at 60% 50%,
                rgba(95, 210, 155, 0.18),
                transparent 70%
              );
              border-radius: 14px;
              padding: 16px;
              border: 1px solid rgba(255, 255, 255, 0.06);
              display: grid;
              grid-template-rows: auto 1fr;
              gap: 10px;
            "
          >
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-family: var(--ff-mono);
                font-size: 10px;
                color: rgba(232, 240, 235, 0.6);
              "
            >
              <span>KECHIKISH · OXIRGI 30 MIN</span>
              <span style="color: #86d4af">p95 = 412ms</span>
            </div>
            <svg
              [attr.viewBox]="'0 0 240 120'"
              preserveAspectRatio="none"
              style="width: 100%; height: 120px"
            >
              <path [attr.d]="sparkArea(latency, 120)" fill="url(#sg-light)" />
              <polyline
                [attr.points]="sparkPoints(latency, 120)"
                fill="none"
                stroke="#86d4af"
                stroke-width="1.6"
                stroke-linejoin="round"
                stroke-linecap="round"
              />
            </svg>
          </div>
        </div>
        <!-- Tile 2: 2-col emerald -->
        <div class="tile tile--span2 tile--emerald reveal">
          <span class="eyebrow">{{ 'LANDING.FEATURES.TILE_OFFLINE_EYEBROW' | translate }}</span>
          <h3>{{ 'LANDING.FEATURES.TILE_OFFLINE_TITLE' | translate }}</h3>
          <p>{{ 'LANDING.FEATURES.TILE_OFFLINE_DESC' | translate }}</p>
          <div class="tile__art" style="display: grid; place-items: center">
            <svg width="120" height="120" viewBox="0 0 84 84">
              <circle cx="42" cy="42" r="32" fill="none" stroke="#e8ece6" stroke-width="8" />
              <circle
                cx="42"
                cy="42"
                r="32"
                fill="none"
                stroke="#178654"
                stroke-width="8"
                stroke-linecap="round"
                [attr.stroke-dasharray]="donutCircumference"
                [attr.stroke-dashoffset]="donutOffset(99.97)"
                transform="rotate(-90 42 42)"
              />
              <text
                x="42"
                y="46"
                text-anchor="middle"
                font-size="12"
                font-weight="700"
                font-family="Manrope"
                fill="#0a1410"
              >
                99.97%
              </text>
            </svg>
          </div>
        </div>
        <!-- Tile 3: 2-col -->
        <div class="tile tile--span2 reveal">
          <span class="eyebrow">{{ 'LANDING.FEATURES.TILE_MULTI_EYEBROW' | translate }}</span>
          <h3>{{ 'LANDING.FEATURES.TILE_MULTI_TITLE' | translate }}</h3>
          <p>{{ 'LANDING.FEATURES.TILE_MULTI_DESC' | translate }}</p>
          <div class="tile__art" style="position: relative">
            @for (
              n of [
                { t: 12, l: 8, label: 'Toshkent' },
                { t: 30, l: 50, label: 'Samarqand' },
                { t: 60, l: 20, label: 'Buxoro' },
                { t: 50, l: 70, label: 'Andijon' },
                { t: 80, l: 60, label: 'Qashqadaryo' },
              ];
              track n.label
            ) {
              <div
                [style.top.%]="n.t"
                [style.left.%]="n.l"
                style="
                  position: absolute;
                  background: var(--paper);
                  border: 1px solid var(--line);
                  border-radius: 8px;
                  padding: 4px 10px;
                  font-size: 11px;
                  font-family: var(--ff-mono);
                  box-shadow: var(--shadow-soft);
                "
              >
                <span
                  style="
                    display: inline-block;
                    width: 6px;
                    height: 6px;
                    border-radius: 999px;
                    background: var(--emerald);
                    margin-right: 6px;
                  "
                ></span
                >{{ n.label }}
              </div>
            }
          </div>
        </div>
        <!-- Tile 4: 2-col -->
        <div class="tile tile--span2 reveal">
          <span class="eyebrow">{{ 'LANDING.FEATURES.TILE_DEVICES_EYEBROW' | translate }}</span>
          <h3>{{ 'LANDING.FEATURES.TILE_DEVICES_TITLE' | translate }}</h3>
          <p>{{ 'LANDING.FEATURES.TILE_DEVICES_DESC' | translate }}</p>
          <div
            class="tile__art"
            style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 6px"
          >
            @for (
              c of ['Printer', 'Skaner', 'Tarozi', 'Kassa', 'NFC', 'QR', 'mPOS', 'Karta'];
              track c
            ) {
              <div
                style="
                  aspect-ratio: 1;
                  background: var(--bg-2);
                  border: 1px solid var(--line);
                  border-radius: 10px;
                  display: grid;
                  place-items: center;
                  font-size: 10px;
                  font-weight: 600;
                  color: var(--ink-2);
                "
              >
                {{ c }}
              </div>
            }
          </div>
        </div>
        <!-- Tile 5: 2-col -->
        <div class="tile tile--span2 reveal">
          <span class="eyebrow">{{ 'LANDING.FEATURES.TILE_SECURITY_EYEBROW' | translate }}</span>
          <h3>{{ 'LANDING.FEATURES.TILE_SECURITY_TITLE' | translate }}</h3>
          <p>{{ 'LANDING.FEATURES.TILE_SECURITY_DESC' | translate }}</p>
          <div
            class="tile__art"
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 10px;
              flex-wrap: wrap;
            "
          >
            @for (
              c of [
                'Ma’lumot himoyasi',
                'Zaxira nusxa',
                'Kirish nazorati',
                'Faollik tarixi',
                'Bulut sinxroni',
              ];
              track c
            ) {
              <span
                style="
                  padding: 8px 14px;
                  border-radius: 999px;
                  background: var(--paper);
                  border: 1px solid var(--line);
                  font-size: 12px;
                  font-weight: 600;
                  font-family: var(--ff-mono);
                "
                >{{ c }}</span
              >
            }
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ════════════════ REALTIME SYNC ════════════════ -->
  <section class="section">
    <div class="wrap reveal">
      <div class="sync">
        <div class="sync__grid">
          <div>
            <span class="eyebrow" style="color: #86d4af">{{
              'LANDING.SYNC.EYEBROW' | translate
            }}</span>
            <h2 style="margin-top: 12px">{{ 'LANDING.SYNC.TITLE' | translate }}</h2>
            <p>{{ 'LANDING.SYNC.DESC' | translate }}</p>
            <div style="margin-top: 28px; display: flex; gap: 24px">
              <div>
                <div
                  style="
                    font-family: var(--ff-mono);
                    font-size: 11px;
                    color: #86d4af;
                    letter-spacing: 0.06em;
                  "
                >
                  {{ 'LANDING.SYNC.STAT1_LABEL' | translate }}
                </div>
                <div
                  style="
                    font-size: 32px;
                    font-weight: 700;
                    letter-spacing: -0.03em;
                    color: white;
                    font-family: var(--ff-mono);
                    margin-top: 4px;
                  "
                >
                  {{ 'LANDING.SYNC.STAT1_VALUE' | translate }}
                </div>
              </div>
              <div>
                <div
                  style="
                    font-family: var(--ff-mono);
                    font-size: 11px;
                    color: #86d4af;
                    letter-spacing: 0.06em;
                  "
                >
                  {{ 'LANDING.SYNC.STAT2_LABEL' | translate }}
                </div>
                <div
                  style="
                    font-size: 32px;
                    font-weight: 700;
                    letter-spacing: -0.03em;
                    color: white;
                    font-family: var(--ff-mono);
                    margin-top: 4px;
                  "
                >
                  {{ 'LANDING.SYNC.STAT2_VALUE' | translate }}
                </div>
              </div>
            </div>
          </div>
          <div class="sync__viz">
            <div class="sync__hub">
              <span style="font-size: 20px; font-family: var(--ff-mono); opacity: 0.8">Miyzan</span>
            </div>
            @for (
              n of [
                { top: 20, left: 8, label: 'Kassa' },
                { top: 28, right: 4, label: 'Qurilmalar' },
                { bottom: 28, left: 4, label: 'Ombor' },
                { bottom: 18, right: 10, label: 'Panel' },
                { top: 50, left: -10, label: 'Printer' },
                { top: 50, right: -10, label: 'Filial' },
              ];
              track n.label
            ) {
              <div
                class="sync__node"
                [style.top.%]="n.top || null"
                [style.bottom.%]="n.bottom || null"
                [style.left.%]="n.left !== undefined ? n.left : null"
                [style.right.%]="n.right !== undefined ? n.right : null"
              >
                <span class="live"></span>{{ n.label }}
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ════════════════ MOBILE ════════════════ -->
  <section class="section">
    <div class="wrap">
      <div class="mobile">
        <div class="phone reveal">
          <div class="phone__screen">
            <span class="phone__notch"></span>
            <div class="phone__bar">
              <span>14:08</span>
              <span style="font-weight: 600">● ● ●</span>
            </div>
            <div class="phone__body">
              <div
                style="
                  font-size: 11px;
                  font-family: var(--ff-mono);
                  text-transform: uppercase;
                  letter-spacing: 0.08em;
                  color: var(--muted);
                "
              >
                Bugun
              </div>
              <div
                style="
                  font-size: clamp(24px, 6vw, 38px);
                  font-weight: 800;
                  letter-spacing: -0.04em;
                  line-height: 1;
                  margin-top: 4px;
                  font-family: var(--ff-mono);
                "
              >
                UZS 4.82M
              </div>
              <div
                style="
                  font-size: clamp(8px, 3vw, 12px);
                  color: var(--emerald-deep);
                  font-weight: 600;
                  margin-top: 4px;
                "
              >
                ▲ kechagiga nisbatan 18.2%
              </div>
              <div
                style="
                  margin-top: 16px;
                  background: white;
                  border: 1px solid var(--line);
                  border-radius: 14px;
                  padding: 14px;
                  box-shadow: var(--shadow-soft);
                "
              >
                <svg
                  [attr.viewBox]="'0 0 240 56'"
                  preserveAspectRatio="none"
                  style="width: 100%; height: 56px"
                >
                  <path [attr.d]="sparkArea(phoneData, 56)" fill="url(#sg-green)" />
                  <polyline
                    [attr.points]="sparkPoints(phoneData, 56)"
                    fill="none"
                    stroke="#1f9d6a"
                    stroke-width="1.6"
                    stroke-linejoin="round"
                    stroke-linecap="round"
                  />
                </svg>
              </div>
              <div
                style="
                  margin-top: 14px;
                  font-size: 11px;
                  font-family: var(--ff-mono);
                  text-transform: uppercase;
                  letter-spacing: 0.08em;
                  color: var(--muted);
                "
              >
                Hozir jonli
              </div>
              @for (
                r of [
                  ['Toshkent', 'UZS 482K'],
                  ['Samarqand', 'UZS 218K'],
                  ['Buxoro', 'UZS 142K'],
                ];
                track r[0]
              ) {
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 10px 14px;
                    background: white;
                    border: 1px solid var(--line);
                    border-radius: 12px;
                    margin-top: 6px;
                  "
                >
                  <div style="display: flex; align-items: center; gap: 8px">
                    <span
                      style="
                        width: 6px;
                        height: 6px;
                        border-radius: 999px;
                        background: var(--emerald);
                        box-shadow: 0 0 6px var(--emerald-glow);
                        display: inline-block;
                      "
                    ></span>
                    <span style="font-size: 12px; font-weight: 600">{{ r[0] }}</span>
                  </div>
                  <span style="font-family: var(--ff-mono); font-weight: 700; font-size: 12px">{{
                    r[1]
                  }}</span>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="reveal">
          <span class="eyebrow">{{ 'LANDING.MOBILE.EYEBROW' | translate }}</span>
          <h2
            style="
              font-size: clamp(40px, 5vw, 64px);
              margin-top: 14px;
              letter-spacing: -0.045em;
              line-height: 1;
            "
          >
            {{ 'LANDING.MOBILE.TITLE_1' | translate }}<br />{{
              'LANDING.MOBILE.TITLE_2' | translate
            }}
          </h2>
          <p
            style="
              font-size: 19px;
              color: var(--muted);
              margin-top: 18px;
              line-height: 1.5;
              max-width: 480px;
            "
          >
            {{ 'LANDING.MOBILE.DESC' | translate }}
          </p>
          <ul style="list-style: none; padding: 0; margin-top: 24px; display: grid; gap: 10px">
            @for (key of ['LIST_1', 'LIST_2', 'LIST_3', 'LIST_4', 'LIST_5']; track key) {
              <li
                style="
                  display: flex;
                  gap: 12px;
                  align-items: flex-start;
                  font-size: 15px;
                  color: var(--ink-2);
                "
              >
                <span
                  style="
                    width: 20px;
                    height: 20px;
                    border-radius: 999px;
                    background: var(--emerald-mist);
                    display: grid;
                    place-items: center;
                    flex-shrink: 0;
                    margin-top: 2px;
                    color: var(--emerald-deep);
                    font-size: 12px;
                    font-weight: 700;
                  "
                  >✓</span
                >
                {{ `LANDING.MOBILE.${key}` | translate }}
              </li>
            }
          </ul>
          <button
            class="btn btn--emerald btn--lg"
            style="margin-top: 28px"
            (click)="scrollTo('apply')"
          >
            {{ 'LANDING.MOBILE.CTA' | translate }}
          </button>
        </div>
      </div>
    </div>
  </section>

  <!-- ════════════════ PRICING ════════════════ -->
  <app-pricing></app-pricing>

  <!-- ════════════════ CTA + ARIZA YUBORISH ════════════════ -->
  <app-apply-form></app-apply-form>

  <!-- ════════════════ FLOATING CALL BUTTON ════════════════ -->
  <div class="call-float" [class.call-float--open]="callMenuOpen()">
    <!-- Phone list popup -->
    @if (callMenuOpen()) {
      <div class="call-menu" (click)="$event.stopPropagation()">
        <div class="call-menu__title">{{ 'LANDING.CALL.TITLE' | translate }}</div>
        @for (phone of phones; track phone.href) {
          <a [href]="phone.href" class="call-menu__item">
            <span class="call-menu__icon">
              <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
                <path
                  d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
                />
              </svg>
            </span>
            {{ phone.label }}
          </a>
        }
      </div>
    }

    <!-- Main trigger button -->
    <button
      class="call-fab"
      (click)="callMenuOpen.set(!callMenuOpen())"
      [attr.aria-label]="callMenuOpen() ? 'Yopish' : 'Qo\'ng\'iroq qilish'"
    >
      @if (callMenuOpen()) {
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          width="24"
          height="24"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      } @else {
        <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
          <path
            d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
          />
        </svg>
      }
    </button>
  </div>

  <!-- Backdrop to close menu -->
  @if (callMenuOpen()) {
    <!-- eslint-disable -->
    <div class="call-backdrop" (click)="callMenuOpen.set(false)"></div>
  }

  <!-- ════════════════ FOOTER ════════════════ -->
  <footer class="foot-section" id="connection">
    <div class="foot-inner">
      <!-- ── TOP: 3 columns ── -->
      <div class="foot-top">
        <!-- Col 1: Takliflar (2 sub-columns) -->
        <div class="foot-col foot-col--offers">
          <h4 class="foot-heading">{{ 'LANDING.FOOTER.OFFERS_TITLE' | translate }}</h4>
          <div class="foot-offers-grid">
            <ul class="foot-links">
              <li>
                <a href="#">{{ 'LANDING.FOOTER.POS' | translate }}</a>
              </li>
              <li>
                <a href="#">{{ 'LANDING.FOOTER.WAREHOUSE' | translate }}</a>
              </li>
              <li>
                <a href="#">{{ 'LANDING.FOOTER.ATTENDANCE' | translate }}</a>
              </li>
              <li>
                <a href="#">{{ 'LANDING.FOOTER.REPORTS' | translate }}</a>
              </li>
            </ul>
            <ul class="foot-links">
              <li>
                <a href="#">{{ 'LANDING.FOOTER.CUSTOMERS_DB' | translate }}</a>
              </li>
              <li>
                <a href="#" target="_blank" rel="noopener"
                  >{{ 'LANDING.FOOTER.INTEGRATIONS' | translate }}
                  <span class="foot-ext">↗</span></a
                >
              </li>
              <li>
                <a href="#" target="_blank" rel="noopener"
                  >{{ 'LANDING.FOOTER.API' | translate }} <span class="foot-ext">↗</span></a
                >
              </li>
              <li>
                <a href="#" target="_blank" rel="noopener"
                  >{{ 'LANDING.FOOTER.DOCS' | translate }} <span class="foot-ext">↗</span></a
                >
              </li>
            </ul>
          </div>
        </div>

        <!-- Col 2: Kompaniya -->
        <div class="foot-col">
          <h4 class="foot-heading">{{ 'LANDING.FOOTER.COMPANY_TITLE' | translate }}</h4>
          <ul class="foot-links">
            <li>
              <a href="#">{{ 'LANDING.FOOTER.ABOUT' | translate }}</a>
            </li>
            <li>
              <a href="#pricing">{{ 'LANDING.FOOTER.PRICING' | translate }}</a>
            </li>
            <li>
              <a href="#" target="_blank" rel="noopener"
                >{{ 'LANDING.FOOTER.JOBS' | translate }} <span class="foot-ext">↗</span></a
              >
            </li>
            <li>
              <a href="#connection">{{ 'LANDING.FOOTER.CONTACT' | translate }}</a>
            </li>
          </ul>
        </div>

        <!-- Col 3: Biz bilan bog'lanish -->
        <div class="foot-col">
          <h4 class="foot-heading">{{ 'LANDING.FOOTER.CONTACTS_TITLE' | translate }}</h4>
          <ul class="foot-contacts">
            <li>
              <span class="foot-icon-circ">
                <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                  <path
                    d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
                  />
                </svg>
              </span>
              <a href="tel:+998996063662">+998 99 606 36 62</a>
            </li>
            <li>
              <span class="foot-icon-circ">
                <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                  <path
                    d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"
                  />
                </svg>
              </span>
              <a href="https://t.me/miyzan_uz" target="_blank" rel="noopener">&#64;Miyzan</a>
            </li>
            <li>
              <span class="foot-icon-circ">
                <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                  <path
                    d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                  />
                </svg>
              </span>
              <a href="mailto:miyzan.uz@gmail.com">miyzan.uz@gmail.com</a>
            </li>
          </ul>
        </div>
      </div>

      <!-- ── DIVIDER ── -->
      <div class="foot-divider"></div>

      <!-- ── BOTTOM: 3 columns ── -->
      <div class="foot-bottom">
        <!-- Col 1: Copyright + address + licenses -->
        <div class="foot-copy-col">
          <div class="foot-copy-year">{{ 'LANDING.FOOTER.COPYRIGHT' | translate }}</div>
          <div class="foot-copy-addr">{{ 'LANDING.FOOTER.ADDRESS' | translate }}</div>
          <!-- <div class="foot-copy-licenses">
            <div>Guvohnoma №0001 2024-yildan</div>
            <div>Litsenziya №0002 2024-yil 1-yanvardan</div>
            <div>Ruxsatnoma №0003</div>
          </div> -->
        </div>

        <!-- Col 2: Social -->
        <div class="foot-social-col">
          <h4 class="foot-heading">{{ 'LANDING.FOOTER.SOCIAL_TITLE' | translate }}</h4>
          <div class="foot-socials">
            <a
              href="https://t.me/miyzan_uz"
              target="_blank"
              rel="noopener"
              class="foot-social-circ"
              aria-label="Telegram"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                <path
                  d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"
                />
              </svg>
            </a>
            <a
              href="https://youtube.com/@miyzan_erp"
              target="_blank"
              rel="noopener"
              class="foot-social-circ"
              aria-label="YouTube"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                <path
                  d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"
                />
              </svg>
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61565321050126&sk=photos"
              target="_blank"
              rel="noopener"
              class="foot-social-circ"
              aria-label="Facebook"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                <path
                  d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
                />
              </svg>
            </a>
            <a
              href="https://instagram.com/miyzan_uz"
              target="_blank"
              rel="noopener"
              class="foot-social-circ"
              aria-label="Instagram"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                <path
                  d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
                />
              </svg>
            </a>
            <a
              href="https://www.linkedin.com/in/miyzan-uz/"
              target="_blank"
              rel="noopener"
              class="foot-social-circ"
              aria-label="LinkedIn"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                <path
                  d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
                />
              </svg>
            </a>
          </div>
        </div>

        <!-- Col 3: App download -->
        <!-- <div class="foot-app-col">
          <h4 class="foot-heading">Miyzan'ni yuklab olish</h4>
          <div class="foot-app">
            <div class="foot-qr">
              <svg
                viewBox="0 0 100 100"
                width="100"
                height="100"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="100" height="100" fill="#fff" rx="4" />
                <rect
                  x="8"
                  y="8"
                  width="30"
                  height="30"
                  fill="none"
                  stroke="#111"
                  stroke-width="4"
                  rx="2"
                />
                <rect x="14" y="14" width="18" height="18" fill="#111" rx="1" />
                <rect
                  x="62"
                  y="8"
                  width="30"
                  height="30"
                  fill="none"
                  stroke="#111"
                  stroke-width="4"
                  rx="2"
                />
                <rect x="68" y="14" width="18" height="18" fill="#111" rx="1" />
                <rect
                  x="8"
                  y="62"
                  width="30"
                  height="30"
                  fill="none"
                  stroke="#111"
                  stroke-width="4"
                  rx="2"
                />
                <rect x="14" y="68" width="18" height="18" fill="#111" rx="1" />
                <rect x="46" y="8" width="8" height="8" fill="#111" rx="1" />
                <rect x="46" y="20" width="8" height="8" fill="#111" rx="1" />
                <rect x="8" y="46" width="8" height="8" fill="#111" rx="1" />
                <rect x="20" y="46" width="8" height="8" fill="#111" rx="1" />
                <rect x="46" y="46" width="8" height="8" fill="#111" rx="1" />
                <rect x="58" y="46" width="8" height="8" fill="#111" rx="1" />
                <rect x="70" y="46" width="8" height="8" fill="#111" rx="1" />
                <rect x="82" y="46" width="8" height="8" fill="#111" rx="1" />
                <rect x="46" y="58" width="8" height="8" fill="#111" rx="1" />
                <rect x="58" y="58" width="8" height="8" fill="#111" rx="1" />
                <rect x="70" y="70" width="8" height="8" fill="#111" rx="1" />
                <rect x="82" y="82" width="8" height="8" fill="#111" rx="1" />
                <rect x="46" y="82" width="8" height="8" fill="#111" rx="1" />
                <rect x="58" y="70" width="8" height="8" fill="#111" rx="1" />
                <rect x="82" y="58" width="8" height="8" fill="#111" rx="1" />
                <rect x="32" y="32" width="8" height="8" fill="#111" rx="1" />
              </svg>
            </div>
            <div class="foot-store-btns">
              <a href="#" class="foot-store-btn" target="_blank" rel="noopener">
                <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                  <path
                    d="M3.18 23.76c.31.17.65.24 1 .24.55 0 1.1-.18 1.54-.53l10.38-6.01-2.83-2.83-10.09 9.13zM.54 1.96C.2 2.37 0 2.94 0 3.64v16.72c0 .7.2 1.27.54 1.68l.09.09 9.36-9.36v-.22L.63 1.87l-.09.09zM20.1 10.3l-2.96-1.72-3.17 3.17 3.17 3.17 2.98-1.72c.85-.49.85-1.29-.02-1.9zM4.18.53C3.44-.02 2.55-.16 1.82.26L12.04 10.5l-2.83-2.83L4.18.53z"
                  />
                </svg>
                <span>Google Play</span>
              </a>
              <a href="#" class="foot-store-btn" target="_blank" rel="noopener">
                <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                  <path
                    d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"
                  />
                </svg>
                <span>App Store</span>
              </a>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </footer>
</div>
